import { css } from '@emotion/core';
import React from 'react';

import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import CountDown from './CountDown';

import './TimeLimitedDiscount.scss';

const TimeLimitedDiscount = ({
  title,
  description,
  product,
  expiresAt,
  primaryColor,
  uiVariantCountdown,
}) => {
  const countdownStyle = css`
    .countdown-col {
      @media (min-width: 992px) {
        padding-right: 130px;
      }
      @media (min-width: 1200px) {
        padding-right: 150px;
      }
    }
    &.variant-1 {
      border: 1px solid ${primaryColor};
      border-radius: 12px;

      .title {
        color: ${primaryColor};
      }
    }

    &.variant-2 {
      .title {
        color: #4f4f4f;
      }
    }

    &.variant-3 {
      .title {
        color: #4f4f4f;
      }
    }
  `;

  return (
    <div
      className={`time-limited-discount variant-${uiVariantCountdown}`}
      css={countdownStyle}
    >
      <div className="row">
        <div className="col-md-6 countdown-col">
          <div className="title">{title}</div>
          <div className="offer-description">{description}</div>
          <div className="timer">
            <CountDown
              timeEnd={expiresAt}
              primaryColor={primaryColor}
              uiVariantCountdown={uiVariantCountdown}
            />
          </div>
        </div>
        <div className="col-md-6">
          <ProductThumbnail
            product={product}
            uiVariant={uiVariantCountdown}
            isCountdown
          />
        </div>
      </div>
    </div>
  );
};

export default TimeLimitedDiscount;
